import Marquee from "react-fast-marquee";

export const MarqueeRibbon = () => (
    <div data-testid="editorial-marquee" className="overflow-hidden border-y border-vault-border bg-vault-black py-6">
        <Marquee speed={35} gradient={false}>
            {[0, 1, 2, 3].map((i) => (
                <span key={i} className="mx-6 whitespace-nowrap font-display text-4xl uppercase text-outline-red md:text-6xl">
                    Hand painted in the streets&nbsp;&nbsp;·&nbsp;&nbsp;No replicas&nbsp;&nbsp;·&nbsp;&nbsp;1 of
                    1&nbsp;&nbsp;·&nbsp;&nbsp;Vault Deportivos&nbsp;&nbsp;·
                </span>
            ))}
        </Marquee>
    </div>
);
